$(function () {
  var imgs = $('#edGallery .edud-gphoto img').map(function () { return $(this).attr('src'); }).get();
  if (!imgs.length) return;

  var $lb = $('#eduLightbox');
  if (!$lb.length) return;

  function lpad(n) { return (n < 10 ? '0' : '') + n; }
  var idx = 0;
  function show(i) {
    idx = (i + imgs.length) % imgs.length;
    var $fig = $lb.find('.edud-lb__figure').removeClass('is-swap');
    $lb.find('.edud-lb__img').attr('src', imgs[idx]);
    $lb.find('.edud-lb__count').text(lpad(idx + 1) + ' — ' + lpad(imgs.length));
    void $fig[0].offsetWidth; $fig.addClass('is-swap');
  }
  function open(i) {
    show(i);
    $lb.addClass('is-open').attr('aria-hidden', 'false');
    $('body').addClass('lb-open');
    $lb.find('.edud-lb__close').focus();
  }
  function close() {
    $lb.removeClass('is-open').attr('aria-hidden', 'true');
    $('body').removeClass('lb-open');
  }
  $('#edGallery').off('click.lb keydown.lb')
    .on('click.lb', '.edud-gphoto', function () { open(+$(this).attr('data-lb')); })
    .on('keydown.lb', '.edud-gphoto', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(+$(this).attr('data-lb')); }
    });
  $lb.find('.edud-lb__next').off('click').on('click', function () { show(idx + 1); });
  $lb.find('.edud-lb__prev').off('click').on('click', function () { show(idx - 1); });
  $lb.find('.edud-lb__close').off('click').on('click', close);
  $lb.off('click').on('click', function (e) { if (e.target === this) close(); });
  $(document).off('keydown.lb').on('keydown.lb', function (e) {
    if (!$lb.hasClass('is-open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight') show(idx + 1);
    else if (e.key === 'ArrowLeft') show(idx - 1);
  });
});
